
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Image } from "lucide-react";
import { ChangeEvent } from "react";

interface PreviewImageFieldProps {
  previewImage: File | null | undefined;
  onChange: (file: File) => void;
}

export function PreviewImageField({ previewImage, onChange }: PreviewImageFieldProps) {
  const handlePreviewImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      onChange(e.target.files[0]);
    }
  };

  return (
    <div>
      <Label htmlFor="preview-image">Εικόνα Προεπισκόπησης</Label>
      <div className="mt-1">
        <div className="relative">
          <Image className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
          <Input 
            id="preview-image"
            type="file"
            accept="image/*"
            onChange={handlePreviewImageChange}
            className="pl-10"
          />
        </div>
        {previewImage && (
          <div className="mt-2">
            <img 
              src={URL.createObjectURL(previewImage)} 
              alt="Προεπισκόπηση" 
              className="h-32 object-cover rounded-md"
            />
          </div>
        )}
      </div>
    </div>
  );
}
